import flatReducer from './flatCollection';
import { combineReducers } from 'redux';
import { reducer as newCollectionReducer } from 'Reducers/newCollection';
const makeInitialState = {
    isFetching: false,
    isError: false,
    data: []
};

const popularBrandsInitialState = {
    isFetching: false,
    isError: false,
    data: []
};

const modelInitialState = {
    elements: {},
    collections: {},
    isFetching: {},
    isError: {},
    collectionMetadata: {}
};

export const MAKE_TYPE = 'MAKE-OLXAUTOS';
export const MODEL_TYPE = 'MODEL-OLXAUTOS';
export const POPULAR_BRANDS_TYPE = 'POPULAR-BRANDS-OLXAUTOS';

const makeReducer = (state = makeInitialState, action) => {
    return flatReducer(state, action, MAKE_TYPE);
};

const modelReducer = (state = modelInitialState, action) => {
    return newCollectionReducer(state, action, MODEL_TYPE);
};

const popularBrandsReducer = (state = popularBrandsInitialState, action) => {
    return flatReducer(state, action, POPULAR_BRANDS_TYPE);
};

export default combineReducers({
    make: makeReducer,
    model: modelReducer,
    popularBrands: popularBrandsReducer
});
